import { snakeCase } from 'lodash';

import { ClientPresentationV2EstateInsightsBundleConfiguration } from '@/modules/presentation/clientPresentation/types/ClientPresentation.PresentationBundleType';

type LegacyEstateInsightsPageFlagField = {
  [K in keyof ClientPresentationV2EstateInsightsBundleConfiguration]: ClientPresentationV2EstateInsightsBundleConfiguration[K] extends boolean
    ? K
    : never;
}[keyof ClientPresentationV2EstateInsightsBundleConfiguration];

// Remove this compatibility map when the backend removes the legacy fields.
export const legacyInsightKindToConfigField: Record<
  string,
  LegacyEstateInsightsPageFlagField
> = {
  EX_SPOUSE_LISTED_IN_WILL: 'includeExSpouseListedInWillPage',
  MISSING_GUARDIAN_PROVISIONS: 'includeMissingGuardianProvisionsPage',
  NO_ALTERNATIVE_AGENT_LISTED_POA: 'includeNoAlternativeAgentListedPoaPage',
  NO_ALTERNATIVE_AGENT_LISTED_HEALTHCARE_PROXY:
    'includeNoAlternativeAgentListedHealthcareProxyPage',
  TRUSTEES_NOT_UPDATED: 'includeTrusteesNotUpdatedPage',
  EX_SPOUSE_LISTED_AS_TRUSTEE: 'includeExSpouseListedAsTrusteePage',
  EX_SPOUSE_LISTED_AS_BENEFICIARY: 'includeExSpouseListedAsBeneficiaryPage',
  AUTOMATIC_OUTRIGHT_DISTRIBUTION_TO_SPOUSE:
    'includeAutomaticOutrightDistributionToSpousePage',
  MISSING_POWERS_OF_APPOINTMENT_FOR_SURIVIVING_SPOUSE:
    'includeMissingPoaForSurivivingSpousePage',
  OUTRIGHT_DISTRIBUTIONS_TO_CHILDREN:
    'includeOutrightDistributionsToChildrenPage',
  BYPASS_TRUST_FUNDED_SOLELY_VIA_DISCLAIMER:
    'includeBypassTrustFundedSolelyViaDisclaimerPage',
  CORPORATE_TRUSTEE: 'includeCorporateTrusteePage',
  ANNUAL_EXCLUSION_GIFTING: 'includeAnnualExclusionGiftingPage',
  FULL_USE_OF_LIFETIME_EXEMPTION: 'includeFullUseOfLifetimeExemptionPage',
  OPEN_529_ACCOUNT: 'includeOpen529AccountPage',
  DIFFERENT_STATE_OF_RESIDENCE_FROM_ESTATE_DOCUMENTS:
    'includeDifferentStateOfResidenceFromEstateDocumentsPage',
  SPECIFIC_BEQUESTS_IN_WILL: 'includeSpecificBequestsPage',
  TRUSTEE_DOMICILED_IN_DIFFERENT_STATE:
    'includeTrusteeDomiciledInDifferentState',
  RETITLE_ASSETS_TO_REVOCABLE_TRUST: 'includeRetitleAssetsToRevocableTrustPage',
  GIFT_TO_CHARITY: 'includeGiftToCharityPage',
  RETIREMENT_ACCOUNT_BENEFICIARY_DESIGNATIONS:
    'includeRetirementAccountBeneficiaryDesignationsPage',
};

export function getLegacyEstateInsightPageSearchParam(kind: string) {
  const configField = legacyInsightKindToConfigField[kind];
  return configField ? snakeCase(configField) : undefined;
}
